import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

interface IDotMenu {
    options: {
        name: string;
        onClick: (event: any) => void;
    }[];
    id?: string;
    isNotPadding?: boolean;
}

export default function DotMenu(props: IDotMenu) {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
        event.preventDefault();
    };

    const handleClose = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setAnchorEl(null);
        event.stopPropagation();
        event.preventDefault();
    };

    return (
        <div key={`dot-button-${props.id}`}>
            <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
                style={{ color: 'grey', fontSize: '2rem' }}
            >
                ···
            </Button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={(e: React.MouseEvent<HTMLElement, MouseEvent>) => handleClose(e)}
            >
                {props.options.map((option) => (
                    <MenuItem
                        key={`dot-menu-${props.id}-${option.name}`}
                        onClick={(evt) => {
                            option.onClick(evt);
                            handleClose(evt);
                        }}
                    >
                        {option.name}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
